import React, { useState } from 'react'
import AdminHeader from './AdminHeader.js'
import { GET_REFUND_PAYMENT } from '../graphql/Query/paymentRefund.js';
import { useMutation, useQuery } from '@apollo/client';
import Loader from '../components/Loader.js';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { UPDATE_PAYMENT_STATUS } from '../graphql/Mutation/paymentRefund.js';
import { toast } from 'react-toastify';
import CustomPagination from '../components/Pagination.js';
import useScrollToTop from '../components/useScrollToTop.js';
import { REFUND_ORDER_MUTATION } from '../graphql/Mutation/Ordre.js';
import clsx from "clsx";


const AdminRefund = () => {
    useScrollToTop();

    const [searchUser, setSearchUser] = useState('');
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [filter, setFilter] = useState('');
    const [activeButton, setActiveButton] = useState('open');
    const [activeButtonRefund, setActiveButtonRefund] = useState('Domestic');
    const [page, setPage] = useState(0);
    const [limit] = useState(200);
    const [updatePaymentRefund] = useMutation(UPDATE_PAYMENT_STATUS);
    const [refundOrder] = useMutation(REFUND_ORDER_MUTATION);
    const { data: paymentRefundData, loading, refetch } = useQuery(GET_REFUND_PAYMENT, {
        variables: {
            page: page + 1,
            limit,
            sort: {
                key: "createdAt",
                type: -1
            },
            filter: filter,
            from: fromDate,
            to: toDate,
            status: activeButton === 'open' ? 'true' : 'false',
            refundType: activeButtonRefund
        },
        fetchPolicy: 'cache-and-network'
    });
    // console.log('✌️paymentRefundData --->', paymentRefundData);

    const handleSearch = (e) => {
        setFilter(searchUser);
        setPage(0);
    }
    const updateStatus = async (id, dataStatus) => {
        try {
            const { data } = await updatePaymentRefund({ variables: { updateRefundPaymentId: id, isActive: dataStatus } });
            if (data.updateRefundPayment) {
                refetch();
                toast.success('PaymentRefund close successfully')

            } else {

                toast.error('Failed to update PaymentRefund status');
            }
        } catch (error) {
            toast.error(error);
        }
    }


    const handleRefund = async (id, orderId, orderAmount) => {
        try {
            const { data } = await refundOrder({
                variables: {
                    refundOrderId: id,
                    orderId: orderId,
                    refundAmount: orderAmount,
                    isRefund: true
                }
            });
            //   console.log("data====",data)
            if (data?.refundOrder?.success) {
                toast.success(data?.refundOrder?.message)
            } else {
                toast.error(data?.refundOrder?.message)
            }

        } catch (error) {
            toast.error(error)
            console.error('Error processing refund:', error);
        }
    };
    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
    }

    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
    };
    return (
        <>
            <AdminHeader />
            <div className="mx-auto max-w-auto px-2 sm:px-6 lg:px-8 my-10">

                <div className="flex flex-wrap justify-between items-center gap-6 bg-white p-4 rounded-lg border border-slate-300">
                    {/* Left Section */}
                    <div className="space-y-4">
                        <h2 className="text- font-semibold text-gray-900">Refund Payment</h2>

                        {/* Refund Type Buttons */}
                        <div className="flex gap-4">
                            {["Domestic", "SingleBikeOrder"].map((type) => (
                                <button
                                    key={type}
                                    className={clsx(
                                        "px-4 py-1.5 rounded-lg font-medium text-sm transition-all duration-300",
                                        activeButtonRefund === type
                                            ? "bg-green-600 text-white"
                                            : "bg-slate-100 text-gray-600 hover:bg-slate-200"
                                    )}
                                    onClick={() => { setActiveButtonRefund(type); setPage(0); }}
                                >
                                    {type}
                                </button>
                            ))}
                        </div>

                        {/* Status Buttons */}
                        <div className="flex gap-4">
                            {[
                                { key: "open", label: "Open", color: "green" },
                                { key: "close", label: "Closed", color: "red" }
                            ].map(({ key, label, color }) => (
                                <button
                                    key={key}
                                    className={clsx(
                                        "px-4 py-1.5 rounded-lg font-medium text-sm transition-all duration-300",
                                        activeButton === key
                                            ? `bg-${color}-600 text-white`
                                            : "bg-slate-100 text-gray-600 hover:bg-slate-200"
                                    )}
                                    onClick={() => { setActiveButton(key); setPage(0); }}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="text-sm font-semibold text-gray-900">
                        Today Refund Payment:
                    </div>
                </div>


                <div className='p-4 mt-6 max-w-full mx-auto bg-slate-50 ring-1 ring-gray-200 rounded-xl space-y-4'>
                    <div className='flex justify-between '>
                        <div>
                            <h2 className="text-xl font-semibold">Shipment Filter</h2>
                        </div>

                    </div>

                    <div className='lg:flex space-y-7 lg:space-y-0 lg:justify-between'>
                        <div>
                            <p className="text-sm font-medium text-gray-700">Search</p>
                            <div className='md:flex md:space-x-4 space-x-0'>
                                <div>
                                    <input type="text" onChange={(e) => setSearchUser(e.target.value)} onKeyDown={handleSearch} value={searchUser} placeholder="Search..." className="mt-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none  px-2 py-1 border rounded-md" />
                                </div>
                            </div>
                        </div>
                        <div className='md:flex md:space-x-4 space-x-0 space-y-3 md:space-y-0'>
                            <div>
                                <p className="text-sm font-medium text-gray-700">From</p>
                                <div className='md:flex md:space-x-4 space-x-0'>
                                    <input
                                        type="date"
                                        className="mt-1 w-full md:w-none  px-2 py-1.5 md:py-1  focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 border rounded-md"
                                        value={fromDate}
                                        onChange={(e) => { fromDateChange(e) }}
                                    />
                                </div>
                            </div>
                            <div>
                                <p className="text-sm font-medium text-gray-700">To</p>
                                <div className='md:flex md:space-x-4 space-x-0'>
                                    <div>
                                        <input
                                            type="date"
                                            className="mt-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none  px-2 py-1.5 md:py-1 border rounded-md"
                                            value={toDate}
                                            onChange={(e) => toDateChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="overflow-x-auto rounded-lg mt-14 border border-gray-300 bg-white">
                    <div className="p-4 border-b rounded-t-lg flex justify-between items-center">
                        <p className="text-base font-semibold text-gray-700">
                            Total: {paymentRefundData?.getPaymentRes?.count}
                        </p>
                    </div>

                    {activeButtonRefund === "Domestic" && (
                        <table className="min-w-full border-collapse">
                            <thead className="bg-slate-50 sticky top-0 z-10 shadow-sm">
                                <tr className="text-gray-600 text-left text-sm">
                                    {[
                                        "No.",
                                        "Date",
                                        "Shipment ID (Cashfree)",
                                        "Transaction ID",
                                        "Customer Ref ID",
                                        "AWB NO.",
                                        "Cancel Reason",
                                        "Transaction Amt.",
                                        "Payment Amt. (CF)",
                                        activeButton !== "close" && "Refund (CF)",
                                        activeButton !== "close" && "Status (Close)",
                                        "View Details",
                                    ]
                                        .filter(Boolean)
                                        .map((header, i) => (
                                            <th key={i} className="py-3 px-4 font-semibold border-b">
                                                {header}
                                            </th>
                                        ))}
                                </tr>
                            </thead>

                            {loading ? (
                                <tbody>
                                    <tr>
                                        <td colSpan={12} className="text-center py-6">
                                            <Loader className="mx-auto" />
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                <tbody>
                                    {paymentRefundData?.getPaymentRes?.data?.map((row, index) => (
                                        <tr key={index} className="hover:bg-slate-50 transition duration-200 border-b last:border-none text-sm">
                                            <td className="py-3 px-4">{index + 1 + page * limit}</td>
                                            <td className="py-3 px-4">{moment(row?.createdAt).format("DD/MM/YYYY hh:mm A")}</td>
                                            <td className="py-3 px-4">{row?.orderDetails?.orderId}</td>
                                            <td className="py-3 px-4">{row?.orderDetails?.paymentDetails[0]?.cf_payment_id}</td>
                                            <td className="py-3 px-4">{row?.createdBy}</td>
                                            <td className="py-3 px-4">{row?.orderDetails?.awb_number}</td>
                                            <td className="py-3 px-4">{row?.cancelReason}</td>
                                            <td className="py-3 px-4">{row?.orderDetails?.order_amount}</td>
                                            <td className="py-3 px-4">{row?.orderDetails?.paymentDetails[0]?.payment_amount}</td>

                                            {activeButton !== "close" && (
                                                <td className="py-3 px-4">
                                                    <button
                                                        onClick={() => handleRefund(row?.id, row?.orderDetails?.orderId, row?.orderDetails?.order_amount)}
                                                        className={`px-4 py-2 text-white rounded-md transition duration-300 ${row?.isRefund ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700"
                                                            }`}
                                                    >
                                                        Refund
                                                    </button>
                                                </td>
                                            )}

                                            {activeButton !== "close" && (
                                                <td className="py-3 px-4">
                                                    <button
                                                        onClick={() => updateStatus(row?.id, false)}
                                                        className="px-4 py-2 border border-gray-900 text-gray-900 rounded-md bg-white hover:bg-slate-900 hover:text-white transition duration-300"
                                                    >
                                                        Close
                                                    </button>
                                                </td>
                                            )}

                                            <td className="py-3 px-4 text-blue-500 font-medium">
                                                <Link to="/admintrack" state={{ id: row?.orderDetails?.id, orderId: row?.orderDetails?.orderId }}>
                                                    View Details
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            )}
                        </table>
                    )}
                </div>



                <div>
                    {paymentRefundData?.getPaymentRes?.count > 0 && (

                        <CustomPagination
                            // pageCount={paymentRefundData?.getPaymentRes?.count? Math.ceil(paymentRefundData.getPaymentRes.count/ limit) : 0}
                            totalItems={paymentRefundData?.getPaymentRes?.count || 0}
                            limit={limit}
                            pageNo={page}
                            handlePageClick={handlePageClick}
                        />)}


                </div>
            </div>
        </>
    )
}

export default AdminRefund
